import Toast from 'services/Toast'

export default client => {
  client.interceptors.response.use(response => response, error => {
    let message = error.response.data.message

    if (error.response.status === 422) {
      let errors = []

      for (let key in error.response.data.errors) {
        errors = [...errors, ...error.response.data.errors[key]]
      }

      message += '<br />' + errors.join('<br />')
    }

    if (error.response.status === 'failed') {
      message = 'Error! Contact administrator'
    }

    Toast.error(message)

    return Promise.reject(error)
  })
}
